import { useRecoilValueLoadable } from 'recoil';
import {
  makePHPRequest,
  methodNameEnum,
} from '../../recoil/selectors/makePHPRequest';

export function useBusinessPermissions() {
  const billingStatus = useRecoilValueLoadable(
    makePHPRequest({
      methodName: methodNameEnum.GET_BILLING_STATUS,
    })
  );

  return {
    // if true the account must be in a read only state due to the customer's expired trial
    accountReadOnly:
      !!billingStatus.contents?.data?.result?.result?.inTrial &&
      !!billingStatus.contents?.data?.result?.result?.trialExpired,
    cardDeclined: !!billingStatus.contents?.data?.result?.result?.cardDeclined,
  };
}
